import React from 'react';
import { Box } from '../../base/Box/Box';
import { TabCarouselSectionStoryblok } from '../../types/storyblok';
import { Type } from '../../base/Type/Type';
import { TabCarouselContentMobile } from './TabCarouselContent/Mobile/TabCarouselContentMobile';
import { TabCarouselContentDesktop } from './TabCarouselContent/Desktop/TabCarouselContentDesktop';

export const TabCarouselSection = ({
  subheading,
  heading,
  cards,
  colourScheme = 'darkGreen',
  overlayOverBkg,
}: TabCarouselSectionStoryblok) => {
  if (!subheading && !heading && !cards) {
    return null;
  }

  return (
    <Box
      as="section"
      colourScheme={colourScheme}
      blockSpacing
      bkg
      overlayOverBkg={overlayOverBkg}
    >
      <Box as="div">
        <Type as="h2" typography="subheading" className="text-center">
          {subheading}
        </Type>
        <Type
          as="h2"
          className="mx-auto mb-6 max-w-3xl text-center font-helvetica text-h2 lg:mb-12"
        >
          {heading}
        </Type>
        <TabCarouselContentDesktop cards={cards} colourScheme={colourScheme} />
        <TabCarouselContentMobile cards={cards} />
      </Box>
    </Box>
  );
};

export default TabCarouselSection;
